
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.41 0h37.8C44.17 0 45 .79 45 1.73v48.69c0 .92-.81 1.73-1.74 1.73H4.36c-.82 0-1.49.64-1.49 1.46S3.54 55 3.83 55H43.6c.78 0 1.41.71 1.41 1.5S44.38 58 43.6 58H3.83C2 58 .07 56 .07 53.64v-.16L0 5.36A5.43 5.43 0 015.41 0z","fill":"#C7CCD7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21 24a4 4 0 11-8 0 4 4 0 018 0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19 26.5c0 .83-.9 1.5-2 1.5s-2-.67-2-1.5.9-1.5 2-1.5 2 .67 2 1.5z","fill":"#7D8290"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35 24a4 4 0 11-8 0 4 4 0 018 0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33 26.5c0 .83-.9 1.5-2 1.5s-2-.67-2-1.5.9-1.5 2-1.5 2 .67 2 1.5z","fill":"#7D8290"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.41 34.91l.04-.01a5.81 5.81 0 01.72-.26c.5-.17 1.23-.36 2.1-.5 1.76-.26 4.05-.25 6.32.77a1 1 0 00.82-1.82 13.28 13.28 0 00-7.43-.92 15.5 15.5 0 00-3.36.9l-.02.01.4.92-.41-.91a1 1 0 00.82 1.82z","fill":"#fff"}})])
          )
        }
      }
    